import { FC, ReactNode } from 'react';
import cx from 'classnames';

import styles from './SectionBox.module.sass';

type SectionBoxSizeType = 'large' | 'medium' | 'medium-new';

interface SectionBoxProps {
  id?: string;
  size?: SectionBoxSizeType;
  children: {
    body: ReactNode;
    title?: ReactNode;
    actions?: ReactNode;
    className?: string;
    headerClassName?: string;
  };
}

const SectionBox: FC<SectionBoxProps> = (props) => {
  const { id, children, size = 'medium' } = props;
  const {
    body,
    title = null,
    actions = null,
    className = '',
    headerClassName = '',
  } = children;

  const showTitle = !!title;
  const showActions = !!actions;
  const showHeader = showTitle || showActions;

  const classes = cx(styles.section, styles[`section--${size}`], className);
  const headerClasses = cx(styles.header, headerClassName);

  return (
    <div id={id} className={classes}>
      {showHeader && (
        <div className={headerClasses}>
          {showTitle && <div className={styles.title}>{title}</div>}
          {showActions && <div className={styles.actions}>{actions}</div>}
        </div>
      )}
      <div className={styles.body}>{body}</div>
    </div>
  );
};

export default SectionBox;
